import { render, staticRenderFns } from "./LoggedInUserAvatar.vue?vue&type=template&id=3b04a508&"
import script from "./LoggedInUserAvatar.vue?vue&type=script&lang=js&"
export * from "./LoggedInUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports